export default {

  getLayout({ layout }) {
    return layout
  }

}
